import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';


export default function VehicleBasicInfoComponent({ handleInnerFormChange, selectedVehicle, transporters, transportAgents }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid grid-cols-1 gap-4'>

            <InputContainer
              label="Transporter Name"
              labelField="UserName"
              list={transporters}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TransporterId'

                );
              }}
              optionName='Choose Transporter'
              type="select"
              value={selectedVehicle?.TransporterId}
              valueField="Id"
            />
            <InputContainer
              label="Transporter Agent Name"
              labelField="Name"
              list={transportAgents}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'TransportAgentId'

                );
              }}
              optionName='Choose TransporterAgent'
              type="select"
              value={selectedVehicle?.TransportAgentId}
              valueField="Id"
            />
            <InputContainer
              label="Vehicle Name"
              name="VehicleName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'VehicleName'

                )
              }}
              type="text"
              value={selectedVehicle?.VehicleName}
            />
            <InputContainer

              label="Registration Number"
              name="RegistrationNumber"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'RegistrationNumber'

                )
              }}
              type="text"
              value={selectedVehicle?.RegistrationNumber}
            />
            <InputContainer

              label="Vehicle Type"
              name="VehicleType"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'VehicleType'

                )
              }}
              type="text"
              value={selectedVehicle?.VehicleType}
            />
            <InputContainer

              label="Vehicle Weight"
              name="VehicleWeight"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'VehicleWeight'

                )
              }}
              type="number"
              value={selectedVehicle?.VehicleWeight}
            />
            <InputContainer

              label="Loading Capacity"
              name="LoadingCapacity"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'LoadingCapacity'

                )
              }}
              type="number"
              value={selectedVehicle?.LoadingCapacity}
            />
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Vehicle Information"
      />

    </>
  )
}